import { types } from "../types/types";
import { fetchConToken } from '../helpers/fetch';
import { openModal, openModalBottom } from './ui';

const ENDPOINT_TEXTOS_LEGALES = 'textoslegales';
const MENSAJE_ERROR_CONEXION = 'Ha habido un error al conectar con el servidor';
const MENSAJE_ERROR_GUARDADO = 'Ha ocurrido un error al guardar los textos legales';
const MENSAJE_GUARDADO_PARCIAL = 'Los cambios anteriores a este error sí se han guardado; el resto sigue pendiente de aplicar.';
const SEGUNDOS_AVISO_EXITO = 3;

export const setTextosLegales = (respuestaTextosLegales) => ({
    type: types.textLegalLoad,
    payload: {
        global: respuestaTextosLegales.global,
        sucursales: respuestaTextosLegales.sucursales,
    }
});

/** Devuelve si se han podido leer, para no ofrecer el editor vacío sobre unos textos que no se conocen. */
export const startLoadTextosLegales = () => {
    return async (dispatch) => {
        try {
            const resp = await fetchConToken(ENDPOINT_TEXTOS_LEGALES);
            const body = await resp.json();
            if (!body.ok) return false;

            dispatch(setTextosLegales(body));
            return true;
        } catch (error) {
            return false;
        }
    }
};

const guardarAmbito = async (cuerpoGuardado) => {
    try {
        const resp = await fetchConToken(ENDPOINT_TEXTOS_LEGALES, cuerpoGuardado, 'PUT');
        return await resp.json();
    } catch (error) {
        return { ok: false, msg: MENSAJE_ERROR_CONEXION };
    }
};

const mostrarErrorDeGuardado = (dispatch, respuestaConError, hayAmbitosGuardados) => {
    const lineasDeError = [respuestaConError.msg || MENSAJE_ERROR_GUARDADO];
    if (hayAmbitosGuardados) lineasDeError.push(MENSAJE_GUARDADO_PARCIAL);

    dispatch(openModal({
        title: 'Error',
        text: lineasDeError,
        buttonText: 'Cerrar'
    }));
};

/**
 * Un PUT por ámbito, en el orden recibido (el global primero) y de uno en uno. Para en el primer
 * error. Cada respuesta trae ya todos los ámbitos, así que el store se queda con la última que fue bien.
 */
export const startGuardarTextosLegales = (cuerposGuardado) => {
    return async (dispatch) => {
        if (cuerposGuardado.length === 0) return false;

        let ultimaRespuestaCorrecta = null;
        for (const cuerpoGuardado of cuerposGuardado) {
            const respuesta = await guardarAmbito(cuerpoGuardado);
            if (!respuesta.ok) {
                const hayAmbitosGuardados = ultimaRespuestaCorrecta !== null;
                if (hayAmbitosGuardados) dispatch(setTextosLegales(ultimaRespuestaCorrecta));
                mostrarErrorDeGuardado(dispatch, respuesta, hayAmbitosGuardados);
                return false;
            }
            ultimaRespuestaCorrecta = respuesta;
        }

        dispatch(setTextosLegales(ultimaRespuestaCorrecta));
        dispatch(openModalBottom({
            text: ['Los textos legales se han guardado correctamente'],
            timeOut: SEGUNDOS_AVISO_EXITO
        }));
        return true;
    }
};
